<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    id="Capa_1"
    x="0px"
    y="0px"
    viewBox="0 0 112.196 112.196"
    style="enable-background:new 0 0 112.196 112.196;"
    xml:space="preserve"
    width="512px"
    height="512px"
    class
  >
    <g>
      <g>
        <circle
          style="fill:#000000"
          cx="56.098"
          cy="56.098"
          r="56.098"
          data-original="#3B5998"
          class
          data-old_color="#3B5998"
        />
        <path
          style="fill:#FFFFFF"
          d="M70.201,58.294h-10.01v36.672H45.025V58.294h-7.213V45.406h7.213v-8.34   c0-5.964,2.833-15.303,15.301-15.303L71.56,21.81v12.51h-8.151c-1.337,0-3.217,0.668-3.217,3.513v7.585h11.334L70.201,58.294z"
          data-original="#FFFFFF"
          class="active-path"
          data-old_color="#FFFFFF"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Facebook'
}
</script>
